import React from 'react'
import moment from 'moment'
import { ChatBubbleOutlineOutlined } from '@mui/icons-material'
import { Flex, Text } from '@fundamentals'
import { localizedStrings } from '@core/strings'

export const LastBriefedRow: React.FC<{ lastBriefedOn: string }> = ({
  lastBriefedOn,
}) => (
  <Flex alignItems='center' gap={1}>
    <ChatBubbleOutlineOutlined
      sx={{
        fontSize: 16,
        color: 'text.secondary',
        flexShrink: 0,
      }}
    />
    <Text fontSize={12} color='text.primary'>
      {`${localizedStrings.lastBriefed}: ${moment(lastBriefedOn).format(
        'Do MMM YYYY HH:mm',
      )}`}
    </Text>
  </Flex>
)
